import React, { useContext } from "react";
import "./PageFifteen.scss";
import { BuildingsContext } from "../../../bContext";

import fil from "../../../assets/film.PNG"
import filEn from "../../../assets/vidEn.png"

function PageFifteen() {
  const { switchToEnglish} = useContext(
    BuildingsContext
  );
  return (
    <>
    <div className="pageFifteen">
      <div className="speech-bubble4">
      {switchToEnglish === false ?
        <p className="first">
          W menu możemy wybrać film.
        </p>
        :
        <p className="first">
        in the menu you can select a movie
      </p>
      }
        <div className="inner-triangle-right4"></div>
      </div>
       <div className="menu-pg4" style={{backgroundImage: !switchToEnglish ? `url(${fil})` : `url(${filEn})` }}></div> 

      <div>
      <div className="speech-bubble5">
      {switchToEnglish === false ?
        <p className="first">
         W przypadku filmu mamy następującą nawigację: "play", "od początku", "poprzedni film, "następny film".
        </p>
        :
        <p className="first">
        In the case of a movie we have the following navigation "play", "from the beginning", "previous movie", "next movie".
       </p>
      }
        <div className="inner-triangle-right5"></div>
      </div>
      <div className="menu-pg5"></div> 
        <div className="modal-header-ins"></div>
        <div className="modalbtn"></div>
        <div className="defaultbtn"></div>
      </div>
    </div>      
    </>
  );
}

export default PageFifteen;
